/* eslint-disable no-console */
/* eslint-disable react/no-unescaped-entities */
// Routes
import routes from "routes";
import footerRoutes from "footer.routes";
// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import DefaultNavbar from "components/Navbars/DefaultNavbar";
import DefaultFooter from "components/Footers/DefaultFooter";
import MKTypography from "components/MKTypography";

// properties details
import YoutubeBackground from "react-youtube-background";
import ScrollTop from "components/ScrollTop";
import { Link } from "react-router-dom";
import LatestAdded from "./sections/properties/LatestAdded";
import MostVisited from "./sections/properties/MostVisited";
import MapZones from "./sections/properties/MapZones";

function Home() {
  return (
    <>
      <DefaultNavbar
        routes={routes}
        /* ****************************pendiente
        action={{
          type: "internal",
          label: "Guía de Uso",
          route: "/",
        }}
        */
        light
        sticky
      />
      <ScrollTop />
      <YoutubeBackground
        className="yt"
        videoId="pNWtxoaJlnc"
        playerOptions={{ mute: 1, loop: 8, autoplay: 1, start: 10 }}
      >
        <MKBox
          minHeight="85vh"
          width="100%"
          sx={{
            // backgroundImage: `url(${bgImage})`,
            // backgroundSize: "cover",
            // backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
            // backgroundColor: "#304A61",
            minHeight: "650px",
          }}
        >
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <br />
            </Grid>
          </Container>
        </MKBox>
      </YoutubeBackground>
      <MKBox
        component="section"
        variant="gradient"
        position="relative"
        py={1}
        px={{ xs: 2, lg: 0 }}
        mx={-2}
        style={{ backgroundColor: "#F0F2F5" }}
      >
        <Container>
          <Grid container>
            <Grid
              item
              xs={12}
              md={8}
              sx={{ mb: 1 }}
              lg={12}
              style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
            >
              <MKTypography
                variant="button"
                color="inherit"
                style={{ fontSize: "18px", textAlign: "center", margin: "auto" }}
              >
                ¿Te gustaría saber como navegar en el sitio? puedes hacerlo accediendo al siguiente
                enlace <Link to="/userguide">Guía de Uso</Link>
              </MKTypography>
            </Grid>
          </Grid>
        </Container>
      </MKBox>
      <MapZones />
      <LatestAdded />
      <MostVisited />
      <MKBox pt={10} px={1} mt={2}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Home;
